import { ACTIONS } from './types';
import GenesysHandler from './helpers/GenesysHandler';

const chatButtonStatus = enabled => ({
  type: ACTIONS.REQUEST_CHAT_BUTTON_ENABLED,
  payload: { chatButtonEnabled: enabled },
});

const chatStateOpen = () => ({
  type: ACTIONS.REQUEST_CHAT_OPEN,
  payload: {},
});

const chatStateClosed = () => ({
  type: ACTIONS.REQUEST_CHAT_CLOSED,
  payload: {},
});

const chatStateErrored = error => ({
  type: ACTIONS.REQUEST_CHAT_ERROR,
  payload: { error },
});

const setChatState = state => ({
  type: ACTIONS.RESOLVE_CHAT_STATE,
  payload: { state },
});

const setSubscription = () => ({
  type: ACTIONS.REQUEST_SUBSCRIBE_TO_CHAT_STATE,
  payload: {},
});

const unsetSubscription = () => ({
  type: ACTIONS.REQUEST_UNSUBSCRIBE_TO_CHAT_STATE,
  payload: {},
});

const setCobrowseSubscription = () => ({
  type: ACTIONS.REQUEST_SUBSCRIBE_TO_COBROWSE_STATE,
  payload: {},
});

const unsetCobrowseSubscription = () => ({
  type: ACTIONS.REQUEST_UNSUBSCRIBE_TO_COBROWSE_STATE,
  payload: {},
});

const setCobrowseState = state => ({
  type: ACTIONS.RESOLVE_COBROWSE_STATE,
  payload: { state },
});

const cobrowseStateErrored = error => ({
  type: ACTIONS.REQUEST_COBROWSE_STATE_ERROR,
  payload: { error },
});

// Text

const textButtonStatus = enabled => ({
  type: ACTIONS.REQUEST_TEXT_BUTTON_ENABLED,
  payload: { textButtonEnabled: enabled },
});

const textStateOpen = () => ({
  type: ACTIONS.REQUEST_TEXT_OPEN,
  payload: {},
});

const textStateClosed = () => ({
  type: ACTIONS.REQUEST_TEXT_CLOSED,
  payload: {},
});

const textStateErrored = error => ({
  type: ACTIONS.REQUEST_TEXT_ERROR,
  payload: { error },
});

const setTextState = state => ({
  type: ACTIONS.RESOLVE_TEXT_STATE,
  payload: { state },
});

const setTextSubscription = () => ({
  type: ACTIONS.REQUEST_SUBSCRIBE_TO_TEXT_STATE,
  payload: {},
});

const unsetTextSubscription = () => ({
  type: ACTIONS.REQUEST_UNSUBSCRIBE_TO_TEXT_STATE,
  payload: {},
});

export const showChatInvite = function showChatInvite() {
  return dispatch => {
    try {
      GenesysHandler.inviteToChat();
    } catch (error) {
      dispatch(chatStateErrored(error));
    }
  };
};

export const enableGenesysChatButton = function enableGenesysChatButton() {
  return dispatch => {
    try {
      GenesysHandler.enableChatButton();
      dispatch(chatButtonStatus(true));
    } catch (error) {
      dispatch(chatStateErrored(error));
    }
  };
};

export const disableGenesysChatButton = function disableGenesysChatButton() {
  return dispatch => {
    try {
      GenesysHandler.disableChatButton();
      dispatch(chatButtonStatus(false));
    } catch (error) {
      dispatch(chatStateErrored(error));
    }
  };
};

export const openGenesysChat = function openChat(formData, autoSubmit = false) {
  return dispatch => {
    try {
      GenesysHandler.openChatWindow(formData, autoSubmit);
      dispatch(chatStateOpen());
    } catch (error) {
      dispatch(chatStateErrored(error));
    }
  };
};

export const closeGenesysChat = function closeChat() {
  return dispatch => {
    try {
      GenesysHandler.closeChatWindow();
    } catch (error) {
      dispatch(chatStateErrored(error));
    }
  };
};

export const subscribeToGenesysChatState = function subscribeToGenesysChatState() {
  return (dispatch, getState) => {
    if (!(getState().genesys || {}).chatEventListenerSet) {
      try {
        GenesysHandler.subscribeToChatState(dispatch, setChatState);
        dispatch(setSubscription());
      } catch (error) {
        dispatch(chatStateErrored(error));
      }
    }
  };
};

export const subscribeToGenesysCobrowseState = function subscribeToGenesysCobrowseState() {
  return (dispatch, getState) => {
    if (!(getState().genesys || {}).cobrowseEventListenerSet) {
      try {
        GenesysHandler.subscribeToCobrowseState(dispatch, setCobrowseState);
        dispatch(setCobrowseSubscription());
      } catch (error) {
        dispatch(cobrowseStateErrored(error));
      }
    }
  };
};

export const unsubscribeToGenesysChatState = function unsubscribeToGenesysChatState() {
  return (dispatch, getState) => {
    if ((getState().genesys || {}).chatEventListenerSet) {
      try {
        GenesysHandler.unsubscribeToChatState(dispatch, setChatState);
        dispatch(unsetSubscription());
      } catch (error) {
        dispatch(chatStateErrored(error));
      }
    }
  };
};

export const unsubscribeToGenesysCobrowseState = function unsubscribeToGenesysCobrowseState() {
  return (dispatch, getState) => {
    if ((getState().genesys || {}).cobrowseEventListenerSet) {
      try {
        GenesysHandler.unsubscribeToCobrowseState(dispatch, setCobrowseState);
        dispatch(unsetCobrowseSubscription());
      } catch (error) {
        dispatch(cobrowseStateErrored(error));
      }
    }
  };
};

// Text

export const enableGenesysTextButton = function enableGenesysTextButton() {
  return dispatch => {
    try {
      GenesysHandler.enableTextButton();
      dispatch(textButtonStatus(true));
    } catch (error) {
      dispatch(textStateErrored(error));
    }
  };
};

export const disableGenesysTextButton = function disableGenesysTextButton() {
  return dispatch => {
    try {
      GenesysHandler.disableChatButton();
      dispatch(textButtonStatus(false));
    } catch (error) {
      dispatch(textStateErrored(error));
    }
  };
};

export const openGenesysText = function openText(formData, autoSubmit = false) {
  return dispatch => {
    try {
      GenesysHandler.openTextWindow(formData, autoSubmit);
      dispatch(textStateOpen());
    } catch (error) {
      dispatch(textStateErrored(error));
    }
  };
};

export const closeGenesysText = function closeText() {
  return dispatch => {
    try {
      GenesysHandler.closeTextWindow();
    } catch (error) {
      dispatch(textStateErrored(error));
    }
  };
};

export const subscribeToGenesysTextState = function subscribeToGenesysTextState() {
  return (dispatch, getState) => {
    if (!(getState().genesys || {}).textEventListenerSet) {
      try {
        GenesysHandler.subscribeToTextState(dispatch, setTextState);
        dispatch(setTextSubscription());
      } catch (error) {
        dispatch(textStateErrored(error));
      }
    }
  };
};

export const unsubscribeToGenesysTextState = function unsubscribeToGenesysTextState() {
  return (dispatch, getState) => {
    if ((getState().genesys || {}).textEventListenerSet) {
      try {
        GenesysHandler.unsubscribeToTextState(dispatch, setTextState);
        dispatch(unsetTextSubscription());
      } catch (error) {
        dispatch(textStateErrored(error));
      }
    }
  };
};
